




































































import { Component, Vue, Prop, Provide, Watch } from 'vue-property-decorator'
import SingleRowSelect from '@/components/common/singleRowSelect/SingleRowSelect.vue'
import filterData from '@/apps/index/components/data'
import { getInitInfo, bookSeries } from './../model/api'
import { getRegions } from '../../index/models/api'

// 北上重天直辖市
const directCities = [110000, 120000, 500000, 310000]

@Component({
  components: { SingleRowSelect }
})
export default class TopFilter2 extends Vue {
  @Prop() site!: any
  public filterList = filterData
  public cityArray: any[] = [] // 市
  public cityIndex = 0
  public province = { name: '全部', val: 0 }

  private get subjectId() {
    return this.$store.state.subject.value
  }

  private showRowItem(item) {
    if (this.bookorkps == 1) {
      if (['textbookVersion', 'paperType'].includes(item.label)) {
        return false
      }
    }
    return true
  }

  private get bookorkps() {
    return this.$store.state.question.bookorkps
  }

  private get regionCode() {
    return this.$store.state.question.region
  }

  private get moduleName() {
    return this.$route.meta.name
  }

  // 用户地区
  private get regions() {
    const user = this.$store.state.user_info
    const regions = user && user.regions
    return regions ? regions.map((m) => {m.val = m.code; return m}) : [{ name: '全部', val: 0 }]
  }

  // mounted
  public mounted() {
    if (this.subjectId) {
      this.getFilters()
    }
  }
  @Watch('subjectId')
  onSubjectIdChange(val) {
    this.getFilters()
  }
  @Watch('regionCode')
  onRegionCodeChange(val: any) {
    if (!this.$store.state.question.provincename) return
    this.getRegions(val, directCities.includes(val))
  }
  @Watch('regions')
  onRegionsChange(val: any) {
    console.log(val);
    if (val && val.length > 0) {
      this.province = val[0]
      this.$store.commit('SET_REGION', val[0].code)
      this.$store.commit('SET_PROVINCENAME', '')
    }
  }
  // 更换省份
  public clickProvince(itm, idx) {
    this.province = itm
    this.$store.commit('SET_REGION', itm.val)
    this.$store.commit('SET_PROVINCENAME', '')
  }
  // 更换城市
  public clickCity(itm, idx) {
    this.cityIndex = idx
    this.$store.commit('SET_REGION', itm.code)
    this.$store.commit('SET_PROVINCENAME', '')
    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter: '市',
      value: itm.name,
      paper_type: ''
    })
  }
  // getRegions
  public async getRegions(val, type) {
    const list = document.getElementsByClassName('bottom')
    const target = list[list.length - 1]
    // 直辖市或全部
    if (val === 0 || type) {
      this.cityArray = []
      target.classList.add('no-bottom')
      return
    }
    try {
      const { data } = await getRegions({
        pcode: val
      })
      this.cityIndex = 0
      target.classList.remove('no-bottom')
      this.cityArray = [{ code: val, name: '全部' }, ...data]
    } catch (e) {}
  }

  /**
   * getChoose
   */
  // methods
  public getChoose(val: any) {
    switch (val.group) {
      case '年级：':
        this.$store.commit('SET_GRADE', val.value)
        break
      case '题型：':
        this.$store.commit('SET_QUESTIONTYPE', val.value)
        this.$store.commit('SET_QUESTIONTYPENAME', val.name)
        break
      case '地区：':
        this.$store.commit('SET_REGION', val.value)
        this.$store.commit('SET_PROVINCENAME', val.name)
        break
      case '年份：':
        this.$store.commit('SET_YEAR', val.value)
        break
      case '难度：':
        this.$store.commit('SET_DIFF', val.value)
        this.$store.commit('SET_DIFFNAME', val.name)
        break
      case '来源：':
        this.$store.commit('SET_PAPER_TYPE', val.value)
        break

      default:
        break
    }
    const filter = val.group.split('：')[0]

    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter,
      value: val.name,
      paper_type: ''
    })
  }
  /**
   * getFilters
   */
  public async getFilters() {
    let grades: any = {
      name: '年级：',
      label: 'grade',
      val: []
    }
    let types: any = {
      name: '题型：',
      label: 'question',
      val: []
    }
    let sections: any = {
      name: '地区：',
      label: 'section',
      val: [{ name: '全部', val: 0 }]
    }
    let citys: any = {
      name: '市：',
      label: 'city',
      val: []
    }
    let years: any = {
      name: '年份：',
      label: 'year',
      val: []
    }
    let difficulty: any = {
      name: '难度：',
      label: 'difficulty',
      val: []
    }
    let paperTypes: any = {
      name: '来源：',
      label: 'paper_type',
      val: []
    }
    let [{ data }, bookSeriesRet] = await Promise.all([
      getInitInfo({
        subject_id: this.subjectId
      }),
      bookSeries({
        subject_id: this.subjectId
      })
    ])
    let paper_type_choice = data.paper_type_choices.map((n) => {
      return { name: n[1], val: n[0] }
    })
    paperTypes.val = [{ name: '全部', val: 0 }, ...paper_type_choice]
    let question_difficulty = data.question_difficulty.map((n) => {
      return { name: n[1], val: n[0] }
    })
    difficulty.val = [{ name: '全部', val: -1 }, ...question_difficulty]
    let question_types = data.question_types.map((n) => {
      return { name: n[1], val: n[0] }
    })
    grades.val = data.grade_choices.map((n) => {
      return { name: n[1], val: n[0] }
    })
    types.val = [{ name: '全部', val: -1 }, ...question_types]
    years.val = data.year_choices.map((n) => {
      return { name: n[1], val: n[0] }
    })
    let region_choices = data.region_choices.map((n) => {
      return { name: n.name, val: n.code }
    })
    sections.val = [{ name: '全部', val: 0 }, ...region_choices]
    // 语文、英语增加年级筛选
    if ([101, 103, 201, 203, 301, 303].includes(this.subjectId)) {
      this.filterList = [grades, types, difficulty, paperTypes, years, sections, citys]
    } else {
      // 年级变为全部
      this.$store.commit('SET_GRADE', 0)
      this.filterList = [types, difficulty, paperTypes, years, sections, citys]
    }
    this.$nextTick(() => {
      const list = document.getElementsByClassName('bottom')
      const target = list[list.length - 1]
      target.classList.add('no-bottom')
    })
    if (data.default_book && data.default_book.length > 0) {
      this.$store.commit('SET_DEFAULTBOOK', data.default_book)
    }
    // if (TP_APP_NAME) {
    //   if (this.regions && this.regions.length > 0) {
    //     this.getChoose({ name: this.regions[0].name, value: this.regions[0].code, group: '地区' })
    //   }
    // }
  }
}
